import { useQuery } from "@tanstack/react-query";

import { reviewKeys } from "@/application/query-keys/review-keys";
import { reviewFlowsRepository } from "@/infrastructure/repositories/review-flows-supabase-repository";

/** The editable flow content for a flow id (null flowId disables the query). */
export function useReviewFlow(flowId: string | null) {
  return useQuery({
    queryKey: reviewKeys.flow(flowId ?? ""),
    queryFn: () => reviewFlowsRepository.get(flowId as string),
    enabled: Boolean(flowId),
    staleTime: 30 * 1000,
  });
}
